// extracted by mini-css-extract-plugin
export default {"header":"AccordionHeader_header__jLVIQ","title":"AccordionHeader_title__ZcK-U","subtitle":"AccordionHeader_subtitle__3I0T6"};